import i18n from 'i18n-literally'

import provinces from 'provinces'
import * as yup from 'yup'

export const getPersonalDataValidationSchema = () => yup.object().shape({
  firstName: yup.string().max(50).required(i18n`first name is required.`),
  lastName: yup.string().max(50).required(i18n`last name is required.`),
  email: yup.string().email().required(i18n`email is required.`),
  retypeEmail: yup.mixed().required(i18n`retype email is required.`).test({
    test: (value, ctx) => {
      if (value !== ctx.parent.email) {
        return ctx.createError({
          message: i18n`emails must match`
        })
      }
      return true
    }
  }),
})

export const getPersonalDataInitialValues = () => ({
  firstName: '',
  lastName: '',
  email: '',
  retypeEmail: ''
})

export const getFacilityInfoValidationSchema = () => yup.object().shape({
  name: yup.string().max(150).required(i18n`facility name is required`),
  state: yup.string().max(5).required(i18n`state or providence is requiered`),
  timezone: yup.string().max(100).required(i18n`timezone is required`)
})

export const getFacilityInfoInitialValues = () => ({
  name: '',
  state: '',
  timezone: ''
})

// list of available countries
const currentCountries = ['US', 'CA', 'DE']

export const getStateProvidenceOpts = () => Object.values(provinces).filter(
  entry => currentCountries.includes(entry.country)
).map(entry => ({
  value: entry.short,
  label: i18n`${entry.name} ${entry.short ? `(${entry.short})` : ''}`
}))
